export class ReportColumnTitles {
    static PROFILE_TAB_TITLES = [
        {title: 'Items', contentUrl: '../app/web/profile-items/profile-items.component.html'},
        {title: 'Categories', contentUrl: ''}
    ];

    static INVENTORY_TAB_TITLES = [
        {title: 'Receiving', contentUrl: '../app/shared/inventory-receiving/inventory-receiving.component.html'},
        {title: 'Add Item', contentUrl: ''}
    ];

    static NEW_ITEM_COLUMNS = [
        {title: 'Item #', key: 'itemNo', width: 70},
        {title: 'Description', key: 'description', width: 160},
        {title: 'Unit Of Measure', key: 'unitOfMeasure', width: 70},
        {title: 'Price', key: 'price', width: 100, format: '{0:c}'},
        {title: 'Critical', key: 'criticalstring', width: 90},
        {title: 'Date Added', key: 'addtime', width: 120},
    ];

    static ORDER_REVIEW_PLACED_REPORT_COLUMNS = [
        {title: 'Item Number', key: 'itemNo', width: 70},
        {title: 'Description', key: 'description', width: 160},
        {title: 'Unit Of Measure', key: 'unitOfMeasure', width: 70},
        {title: 'Cost', key: 'perCost', width: 100, format: '{0:c}'},
        {title: 'Suggested Quantity', key: 'qtySuggested', width: 120},
        {title: 'Order Quantity', key: 'quantity', width: 90, footer: true, footerDesc: 'Quantity'},
        {title: 'Total Cost', key: 'totalCost', width: 120, format: '{0:c}', footer: true, footerDesc: 'Cost', currency: true},
    ];
    static ORDER_REVIEW_CONFIRMED_CONFIRMATION_MESSAGES = [
        {title: 'Item No', key: 'itemNo', width: 70},
        {title: 'Description', key: 'description', width: 160},
        {title: 'Reason', key: 'reason', width: 70},
        {title: 'Suggested Qty', key: 'qtySuggested', width: 120, footer: true},
        {title: 'Confirmed Quantity', key: 'qtyConfirmed', width: 90, footer: true}

    ];

    static ORDER_REVIEW_SHIP_CONFIRM_REPORT_COLUMNS = [
        {title: 'Item No', key: 'itemNo', width: 70},
        {title: 'Description', key: 'description', width: 160},
        {title: 'Unit Of Measure', key: 'unitOfMeasure', width: 70},
        {title: 'Suggested Quantity', key: 'qtySuggested', width: 90},
        {title: 'Ordered Quantity', key: 'orderedQuantity', width: 90},
        {title: 'Confirmed Quantity', key: 'confirmedQuantity', width: 90, footer: true},
        {title: 'Received Quantity', key: 'receivedQuantity', width: 90, footer: true}
    ];

    // MOBILE TITLES:

    static ORDER_REVIEW_MOBILE_PLACED_REPORT_COLUMNS = [
        {title: 'Item No', key: 'itemNo', width: 70},
        {title: 'Description', key: 'description', width: 250},
        {title: 'U-O-M', key: 'unitOfMeasure', width: 75},
        {title: 'Cost', key: 'perCost', width: 75, currency: true},
        {title: 'Sug Qty', key: 'qtySuggested', width: 75},
        {title: 'Order Qty', key: 'quantity', width: 75},
        {title: 'Total Cost', key: 'totalCost', width: 75, format: '{0:c}', currency: true},
    ];

    static ORDER_REVIEW_MOBILE_SHIPPED_REPORT_COLUMNS = [
        {title: 'Item No', key: 'itemNo', width: 75},
        {title: 'Description', key: 'description', width: 250},
        {title: 'U-O-M', key: 'unitOfMeasure', width: 75},
        {title: 'Sug Qty', key: 'qtySuggested', width: 75},
        {title: 'Order Qty', key: 'orderedQuantity', width: 75},
        {title: 'Conf Qty', key: 'confirmedQuantity', width: 75},
        {title: 'Rec Qty', key: 'receivedQuantity', width: 75},
    ];

    static ORDER_REVIEW_MOBILE_CONFIRM_REPORT_COLUMNS = [
        {title: 'Item No', key: 'itemNo', width: 75},
        {title: 'Description', key: 'description', width: 250},
        {title: 'Sug Qty', key: 'qtySuggested', width: 75},
        {title: 'Conf Qty', key: 'qtyConfirmed', width: 75},
        {title: 'Reason', key: 'reason', width: 150},
        {title: 'Reason Code', key: 'reasonCode', width: 75},
    ];

}
